module.exports = __webpack_public_path__ + "img/success-icon.e6b59c03.png";